import ContentEditable from "react-contenteditable";
import React, { Fragment, memo, useCallback, useEffect, useState } from "react";
import { lotPresets } from "../MobilePosition/MobilePositionCreate/mobilePositionCreateConstants.js";
import { BinIcon } from "../../../components/icon/Icon.jsx";
import _ from "lodash";
import { PriceEditableButtonsStyled, PriceEditableStyled } from "./styled/PriceEditableStyled.js";
import { KEY_CODES } from "../../../app/appConstants";

function PriceEditable(props) {
    const {
        value,
        priceIncrement = 0.00001,
        min,
        max,
        onChange,
    } = props;

    const [inited, setInited] = useState(false);
    const [amount, setAmount] = useState('0');
    const [decimals, setDecimals] = useState(2);

    const amountChangeHandler = useCallback((value, bubbleChange = false) => {
        setAmount(value);
        if (bubbleChange && onChange) {
            onChange(parseFloat(value));
        }
    }, [onChange]);

    const keyDownHandler = useCallback((e) => {
        if (e.keyCode === KEY_CODES.ENTER) {
            e.preventDefault();
        }
    }, []);

    useEffect(() => {
        if (!inited) {
            const decimals = -Math.log10(priceIncrement);
            setDecimals(decimals);
            let checkValue = _.floor(value, decimals) || 0;
            if (max !== undefined && checkValue > max) checkValue = max;
            if (min !== undefined && checkValue < min) checkValue = min;
            amountChangeHandler(checkValue.toFixed(decimals));
            setInited(true);
        }
    }, [amountChangeHandler, inited, max, min, priceIncrement, value]);

    const amountChangeHandlerEvent = useCallback((e) => {
        setAmount(e.currentTarget.innerText);
        onChange(parseFloat(e.currentTarget.innerText));
    }, [onChange]);

    const amountFieldBlurHandler = useCallback((e) => {
        const amount = parseFloat(e.currentTarget.innerText.replaceAll(',', '.'));
        let value = _.floor(amount, decimals) || 0;
        if (max !== undefined && value > max) value = max;
        if (min !== undefined && value < min) value = min;
        if (amount !== value || e.currentTarget.innerText.length !== value.toString().length) {
            amountChangeHandler(value.toFixed(decimals), true);
        }
    }, [amountChangeHandler, decimals, max, min]);

    const buttonClickHandler = useCallback((e) => {
        const valueText = e.currentTarget.dataset.value;
        let value;
        if (valueText === 'plus') {
            value = _.round(parseFloat(amount) + priceIncrement, decimals);
        } else if (valueText === 'minus') {
            value = _.round(parseFloat(amount) - priceIncrement, decimals);
        }
        if (max !== undefined && value > max) value = max;
        if (min !== undefined && value < min) value = min;
        if (amount !== value) {
            amountChangeHandler(value.toFixed(decimals), true);
        }
    }, [amount, amountChangeHandler, decimals, max, min, priceIncrement]);

    return <PriceEditableStyled>
        <ContentEditable className={'editable'}
                         onChange={amountChangeHandlerEvent}
                         onBlur={amountFieldBlurHandler}
                         onKeyDown={keyDownHandler}
                         inputMode={'decimal'}
                         html={amount}/>
        <PriceEditableButtonsStyled>
            {
                lotPresets.map(item => <Fragment key={item.value}>
                    <div data-value={item.value} onClick={buttonClickHandler}>
                        {item.icon ? <BinIcon name={item.icon}/> : item.title}
                    </div>
                </Fragment>)
            }
        </PriceEditableButtonsStyled>
    </PriceEditableStyled>
}

export default memo(PriceEditable);
